import styled from 'styled-components';
import TextareaAutosize from 'components/textautosize';
import TextInput from 'components/text-input';
import SubmitButton from 'components/form/components/submit-button';
import _FileInput from 'components/file-input';
import _SimpleBar from 'routes/surface/components/simplebar';
import withForm from 'components/form/hoc/with-form';
import UploadIcon from 'styles/icons/upload.svg';
import { Row } from 'components/layout';
import { color, typography } from 'styles/settings';
import { normalize, withModifiers } from 'utils/styles';

import _ImageList from '@mui/material/ImageList';
import _ImageListItem from '@mui/material/ImageListItem';

export const NameTextInput = styled(withForm(TextInput))`
  color: ${color.neutral.gray};
  font-size: ${normalize('24px')};
  ${typography.font.semiBold};
  height: ${normalize('28px')};
  padding-left: 0;
  width: 90%;
`;

export const Separator = styled.div`
  border-top: 1px solid transparent;
  box-shadow: 0px 1px ${color.neutral.grayLight};
  box-shadow: 0px 1px ${color.neutral.grayDark};
  height: ${normalize('14px')};
  margin: 0 ${normalize('-32px')};
  margin-bottom: ${normalize('20px')};
`;

export const ImagePreview = styled.img`
  height: auto;
  width: auto;
  max-height: 400px;
  max-width: 400px;
`;

export const StyledImage = styled.img`
  height: auto;
  width: auto;
  max-height: 200px;
  /* max-width: 180px; */
  /* opacity: 0.5;
  ${withModifiers('$selected')`
  opacity: 1;
  `} */
  background: white;
  opacity: ${(props) => (!props.selected ? 0.5 : 1)};
`;

export const DeleteButton = styled(withForm(SubmitButton))`
  * {
    color: ${color.ui.danger};
  }
`;

export const Footer = styled(Row)`
  width: 100%;
  margin-top: ${typography.size.md};
  justify-content: space-between;
`;

export const Header = styled(Row)`
  width: 100%;
  justify-content: space-between;
`;

export const Content = styled.div`
  display: flex;
  margin: 0 ${normalize('-32px')};
  margin-top: ${normalize('-30px')};
  height: 100%;
`;

export const ImageContent = styled.div`
  display: flex;
  justify-content: center;
  height: 340px;
  box-sizing: border-box;
  margin: 0 ${normalize('-32px')};
  margin-top: ${normalize('-16px')};
`;

export const FileInput = styled(withForm(_FileInput))`
  width: 100%;
  height: 340px;
  box-sizing: border-box;
  background-color: ${color.neutral.grayLighter};
  background-image: url('${UploadIcon}');
  background-repeat: no-repeat;
  background-size: 42px 42px;
  background-position: center 45%;
  margin-bottom: 5%;

  /* ${withModifiers('$hasFile')`
    background-image: none;
  `} */

  > span {
    padding-top: 6em;
  }
`;

export const FileInputSmall = styled(withForm(_FileInput))`
  width: 210px;
  height: 220px;
  box-sizing: border-box;
  background-color: ${color.neutral.grayLighter};
  background-image: url('${UploadIcon}');
  background-repeat: no-repeat;
  background-size: 42px 42px;
  background-position: center 45%;
  margin-bottom: 5%;

  /* ${withModifiers('$hasFile')`
    background-image: none;
  `} */

  > span {
    padding-top: 6em;
  }

  > img {
    max-width: 200px;
    max-height: 200px;
  }
`;

export const ImageListItem = styled(_ImageListItem)`
  width: 210px;
`;

export const ImageList = styled(_ImageList)`
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  margin-bottom: 5%;

  > span {
    padding-top: 6em;
  }
`;

export const DisabledName = styled.span`
  ${typography.font.title.bold};
  height: 85px;
  font-size: ${typography.size.xxxl};
  margin: 30px;
  margin-bottom: 10px;
  min-height: 81px;
  outline: none;
  resize: none;
  width: 100%;
`;

export const NameEditor = styled(withForm(TextareaAutosize))`
  ${typography.font.title.bold};
  font-size: ${typography.size.xxxl};

  background-color: transparent;
  color: ${color.neutral.plainBlack};
  margin: 30px;
  margin-bottom: 10px;
  min-height: 81px;
  outline: none;
  resize: none;
  width: 90%;

  ::placeholder {
    color: ${color.neutral.plainBlack};
    opacity: 0.4;
  }
`;

export const EditorWrapper = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

export const SimpleBar = styled(_SimpleBar).attrs({
  style: {
    height: '95%',
    maxHeight: '100%',
    overflowX: 'hidden',
    width: '100%',
  },
})`
  .simplebar-content {
    height: inherit;
  }
`;
